// extracted by mini-css-extract-plugin
export default {"greeting":"home_greeting__NDb5k","description":"home_description__Ah9of","start":"home_start__mGu9S"};